import { render, staticRenderFns } from "./recruitmentCollectionH5.vue?vue&type=template&id=01704654&scoped=true"
import script from "./recruitmentCollectionH5.vue?vue&type=script&lang=js"
export * from "./recruitmentCollectionH5.vue?vue&type=script&lang=js"
import style0 from "./recruitmentCollectionH5.vue?vue&type=style&index=0&id=01704654&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01704654",
  null
  
)

export default component.exports